export const dimensionConverter = (
  width,
  height,
  changedWidth,
  changedHeight,
) => {
  let newWidth = changedWidth;
  let newHeight = changedHeight;
  if (changedWidth) newHeight = Math.round(newWidth / (width / height));
  if (changedHeight) newWidth = Math.round(newHeight / (height / width));
  return { width: newWidth, height: newHeight };
};
